module.exports = __webpack_public_path__ + "images/google_meet_logo_ca37d89.png";